import { createAction, handleActions } from "redux-actions";
import { applyPenders } from "redux-pender";
import produce from "immer";
import * as apis from "../../lib/api/score";

/* ACTION TYPE */
const SET_CUSTOMER_ID = "store/SET_CUSTOMER_ID";
const GET_STORES = "store/GET_STORES";

const getStores = async (customer_id) => {
  const count = await apis.getStoreCount(customer_id);
  const stores = [];
  for (const i of Array(parseInt(count, 16)).keys()) {
    const store = await apis.getStores(customer_id, i);
    stores.push(store);
  }
  return stores;
};

const initialState = {
  customerId: "",
  stores: []
};

/* ACTION CREATOR */
/* EXPORT ACTION CREATORS */
export const actionCreators = {
  setCustomerId: createAction(SET_CUSTOMER_ID, value => value),
  getStores: createAction(GET_STORES, getStores)
};

const reducer = handleActions(
  {
    [SET_CUSTOMER_ID]: (state, action) => {
      return produce(state, draft => {
        if (!action) return;
        draft.customerId = action.payload;
      });
    }
  },
  initialState
);

export default applyPenders(reducer, [
  {
    type: GET_STORES,
    onSuccess: (state, action) => {
      return produce(state, draft => {
        if (!action.payload) return;
        const stores = action.payload.map(payload => JSON.parse(payload));
        draft.stores = stores;
      });
    },
    onFailure: state => {
      return produce(state, draft => {
        draft.stores = [];
      });
    }
  },
]);
